const asyncRouterList = [
  {
    path: "/admin",
    name: "Account",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "账户中心",
      icon: "el-icon-s-home",
    },
    // 二级菜单是否展示
    Ischildren: true,
    redirect: "/admin/overview",
    children: [
      {
        path: "overview",
        component: () => import("../../view/Home/account/index.vue"),
        meta: {
          title: "账户概览",
          icon: "el-icon-user",
        },
      },
      {
        path: "order",
        component: () => import("../../view/Home/account/order.vue"),
        meta: {
          title: "订单管理",
          icon: "el-icon-tickets",
        },
      },
      {
        path: "withdrawal",
        component: () => import("../../view/Home/account/withdrawal.vue"),
        meta: {
          title: "提现管理",
          icon: "el-icon-set-up",
        },
        redirect: "/admin/withdrawal/application",
        children: [
          {
            path: "application",
            component: () =>
              import("../../view/Home/account/withdrawal/application.vue"),
          },
          {
            path: "list",
            component: () =>
              import("../../view/Home/account/withdrawal/list.vue"),
          },
          {
            path: "account",
            component: () =>
              import("../../view/Home/account/withdrawal/account.vue"),
          },
        ],
      },
      {
        path: "bill",
        component: () => import("../../view/Home/account/bill.vue"),
        meta: {
          title: "资产管理",
          icon: "el-icon-notebook-2",
        },
        redirect: "/admin/bill/detail",
        children: [
          {
            path: "customtime",
            component: () =>
              import("../../view/Home/account/bill/customtime.vue"),
          },
          {
            path: "statistics",
            component: () =>
              import("../../view/Home/account/bill/statistics.vue"),
          },
          {
            path: "detail",
            component: () => import("../../view/Home/account/bill/detail.vue"),
          },
        ],
      },
      {
        path: "revenue",
        component: () => import("../../view/Home/account/revenue.vue"),
        meta: {
          title: "对公账户",
          icon: "el-icon-bank-card",
        },
        redirect: "/admin/revenue/detail",
        children: [
          {
            path: "detail",
            component: () =>
              import("../../view/Home/account/revenue/detail.vue"),
          },
          {
            path: "history",
            component: () =>
              import("../../view/Home/account/revenue/history.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/management",
    name: "management",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "门店管理",
      icon: "el-icon-s-cooperation",
    },
    Ischildren: true,
    redirect: "/management/store/product",
    children: [
      {
        path: "store",
        component: () => import("../../view/Home/product/store.vue"),
        meta: {
          title: "门店商品管理",
          icon: "el-icon-box",
        },
        redirect: "/management/store/product",
        children: [
          {
            path: "product",
            component: () =>
              import("../../view/Home/product/store/product.vue"),
          },
        ],
      },
      {
        path: "setup",
        component: () => import("../../view/Home/product/setup.vue"),
        meta: {
          title: "门店设置",
          icon: "el-icon-box",
        },
        redirect: "/management/setup/cate",
        children: [
          {
            path: "cate",
            component: () => import("../../view/Home/product/store/cate.vue"),
          },
          {
            path: "tableTop",
            component: () =>
              import("../../view/Home/product/store/tableTop.vue"),
          },
          {
            path: "discount",
            component: () =>
              import("../../view/Home/product/store/discount.vue"),
          },
        ],
      },
      {
        path: "Analyze",
        component: () => import("../../view/Home/product/Analyze.vue"),
        meta: {
          title: "商品导入",
          icon: "el-icon-box",
        },
      },
      // {
      //   path: "Member",
      //   component: () => import("../../view/Home/product/member.vue"),
      //   meta: {
      //     title: "会员导入",
      //     icon: "el-icon-box",
      //   },
      // },
    ],
  },
  {
    path: "/live",
    name: "live",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "直播管理",
      icon: "el-icon-s-cooperation",
      keepAlive: true,
    },
    Ischildren: true,
    redirect: "/live/broadcast",
    children: [
      {
        path: "broadcast",
        component: () => import("../../view/Home/live/broadcast.vue"),
        meta: {
          title: "商品管理",
          icon: "el-icon-shopping-bag-1",
        },
      },
      {
        path: "livelist",
        component: () => import("../../view/Home/live/livelist.vue"),
        meta: {
          title: "直播列表",
          icon: "el-icon-video-camera",
        },
      },
    ],
  },
  {
    path: "/mall",
    name: "mall",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "商城管理",
      icon: "el-icon-s-cooperation",
    },
    Ischildren: true,
    redirect: "/mall/product",
    children: [
      {
        path: "product",
        component: () => import("../../view/Home/product/index.vue"),
        meta: {
          title: "商品管理",
          icon: "el-icon-shopping-bag-1",
        },
        redirect: "/mall/product/onsale",
        children: [
          {
            path: "onsale",
            component: () => import("../../view/Home/product/index/onSale.vue"),
          },
           {
            path: "add",
            component: () => import("../../view/Home/product/index/add.vue"),
          },
        ],
      },
      {
        path: "group",
        component: () => import("../../view/Home/product/group.vue"),
        meta: {
          title: "团购管理",
          icon: "el-icon-shopping-bag-1",
          hidden: true,
        },
        redirect: "/mall/group/buying",
        children: [
          {
            path: "buying",
            component: () => import("../../view/Home/product/index/buying.vue"),
          },
          {
            path: "add",
            component: () => import("../../view/Home/product/index/add.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/shop",
    name: "shop",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "店铺管理",
      icon: "el-icon-s-shop",
    },
    Ischildren: true,
    redirect: "/shop/merchant",
    children: [
      {
        path: "merchant",
        component: () => import("../../view/Home/shop/merchant.vue"),
        meta: {
          title: "店铺资料",
          icon: "el-icon-setting",
        },
        redirect: "/shop/merchant/detail",
        children: [
          {
            path: "detail",
            component: () => import("../../view/Home/shop/merchant/detail.vue"),
          },
          {
            path: "album",
            component: () => import("../../view/Home/shop/merchant/album.vue"),
          },
          {
            path: "label",
            component: () => import("../../view/Home/shop/merchant/label.vue"),
          },
        ],
      },
      {
        path: "store",
        component: () => import("../../view/Home/shop/store.vue"),
        meta: {
          title: "门店设置",
          icon: "el-icon-bangzhu",
        },
        redirect: "/shop/store/discount",
        children: [
          {
            path: "discount",
            component: () =>
              import("../../view/Home/shop/merchant/discount.vue"),
          },
        ],
      },
      {
        path: "staff",
        component: () => import("../../view/Home/shop/staff.vue"),
        meta: {
          title: "员工管理",
          icon: "el-icon-user",
        },
      },
      {
        path: "account",
        component: () => import("../../view/Home/shop/account.vue"),
        meta: {
          title: "子账户管理",
          icon: "el-icon-s-custom",
          hidden: true,
        },
      },
    ],
  },

  {
    path: "/inventory",
    name: "inventory",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "进销存管理",
      icon: "el-icon-s-shop",
    },
    Ischildren: true,
    redirect: "/inventory/suppiler",
    children: [
      {
        path: "suppiler",
        component: () => import("../../view/Home/inventory/suppiler.vue"),
        meta: {
          title: "供应商管理",
          icon: "el-icon-user",
        },
      },
      {
        path: "store",
        component: () => import("../../view/Home/inventory/store.vue"),
        meta: {
          title: "仓库管理",
          icon: "el-icon-s-shop",
        },
      },
      {
        path: "purchaseReturn",
        component: () => import("../../view/Home/inventory/purchaseReturn.vue"),
        meta: {
          title: "采购退货",
          icon: "el-icon-d-arrow-left",
        },
      },
      {
        path: "purchaseApply",
        component: () => import("../../view/Home/inventory/purchaseApply.vue"),
        meta: {
          title: "采购申请",
          icon: "el-icon-document",
        },
      },
      {
        path: "purchaseReview",
        component: () => import("../../view/Home/inventory/purchaseReview.vue"),
        meta: {
          title: "采购审核",
          icon: "el-icon-document",
        },
      },
      {
        path: "purchaseOrder",
        component: () => import("../../view/Home/inventory/purchaseOrder.vue"),
        meta: {
          title: "采购单",
          icon: "el-icon-document",
        },
      },
    ],
  },

  {
    path: "/stock",
    name: "stock",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      requireAuth: true,
      title: "库存管理",
      icon: "el-icon-s-shop",
    },
    Ischildren: true,
    redirect: "/stock/product",
    children: [
      {
        path: "product",
        component: () => import("../../view/Home/stock/product.vue"),
        meta: {
          title: "商品管理",
          icon: "el-icon-shopping-bag-1",
        },
      },
      {
        path: "query",
        component: () => import("../../view/Home/stock/query.vue"),
        meta: {
          title: "库存查询",
          icon: "el-icon-search",
        },
      },
      {
        path: "inout",
        component: () => import("../../view/Home/stock/inout.vue"),
        meta: {
          title: "出入库管理",
          icon: "el-icon-s-data",
        },
      },
      {
        path: "transfer",
        component: () => import("../../view/Home/stock/transfer.vue"),
        meta: {
          title: "调拨单",
          icon: "el-icon-document",
        },
      },
      {
        path: "transferAudit",
        component: () => import("../../view/Home/stock/transferAudit.vue"),
        meta: {
          title: "调拨审核",
          icon: "el-icon-document",
        },
      },
      {
        path: "adjust",
        component: () => import("../../view/Home/stock/adjust.vue"),
        meta: {
          title: "报损报溢",
          icon: "el-icon-document",
        },
      },
      {
        path: "alert",
        component: () => import("../../view/Home/stock/alert.vue"),
        meta: {
          title: "库存预警",
          icon: "el-icon-warning",
        },
      },
      {
        path: "replenishin",
        component: () => import("../../view/Home/stock/replenishin.vue"),
        meta: {
          title: "补货入库",
          icon: "el-icon-box",
        },
      },
      {
        path: "replenishout",
        component: () => import("../../view/Home/stock/replenishout.vue"),
        meta: {
          title: "补货出库",
          icon: "el-icon-box",
        },
      },
      {
        path: "sale",
        component: () => import("../../view/Home/stock/sale.vue"),
        meta: {
          title: "销售出库",
          icon: "el-icon-sell",
        },
      },
      {
        path: "saleReturn",
        component: () => import("../../view/Home/stock/salereturn.vue"),
        meta: {
          title: "销售退货入库",
          icon: "el-icon-refresh-left",
        },
      },
      {
        path: "check",
        component: () => import("../../view/Home/stock/check.vue"),
        meta: {
          title: "仓库盘点",
          icon: "el-icon-s-check",
        },
      },
      {
        path: "statistics",
        component: () => import("../../view/Home/stock/statistics/inout.vue"),
        meta: {
          title: "出入库统计",
          icon: "el-icon-s-data",
        },
      },
      {
        path: "saleReturn/statistics",
        component: () => import("../../view/Home/stock/statistics/sale.vue"),
        meta: {
          title: "销售统计",
          icon: "el-icon-data-analysis",
        },
      },
      // {
      //   path: "expiry",
      //   component: () => import("../../view/Home/stock/expiry.vue"),
      //   meta: {
      //     title: "保质期管理",
      //     icon: "el-icon-time",
      //   },
      // },
    ],
  },
  // 销售管理 (url 为 null 的子项暂注)
  // {
  //   path: "refund",
  //   component: () => import("../../view/Home/sales/refund.vue"),
  //   meta: { title: "退款订单", icon: "el-icon-document" },
  // },
  // {
  //   path: "report",
  //   component: () => import("../../view/Home/sales/report.vue"),
  //   meta: { title: "销售报表", icon: "el-icon-data-line" },
  // },
  // {
  //   path: "saleDelivery",
  //   component: () => import("../../view/Home/sales/saleDelivery.vue"),
  //   meta: { title: "销售出库", icon: "el-icon-d-arrow-right" },
  // },
  // {
  //   path: "saleReturnIn",
  //   component: () => import("../../view/Home/sales/saleReturnIn.vue"),
  //   meta: { title: "销售退货入库", icon: "el-icon-d-arrow-left" },
  // },
  {
    path: "/marketing",
    name: "marketing",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "营销中心",
      icon: "el-icon-s-tools",
      hidden: true,
    },
    redirect: "/marketing/coupon",
    Ischildren: true,
    children: [
      {
        path: "coupon",
        component: () => import("../../view/Home/marketing/coupon.vue"),
        meta: {
          title: "店铺优惠券",
          icon: "el-icon-s-ticket",
        },
        redirect: "/marketing/coupon/index",
        children: [
          {
            path: "index",
            component: () =>
              import("../../view/Home/marketing/coupon/index.vue"),
          },
          {
            path: "add",
            component: () => import("../../view/Home/marketing/coupon/add.vue"),
          },
        ],
      },
      {
        path: "envelope",
        component: () => import("../../view/Home/marketing/envelope.vue"),
        meta: {
          title: "红包引流",
          icon: "el-icon-present",
        },
      },
    ],
  },
  {
    path: "/cashier",
    name: "admincashier",
    component: () => import("../../view/Home/components/container.vue"),
    Ischildren: false,
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "收银台管理",
      icon: "el-icon-s-tools",
      hidden: true,
    },
    redirect: "/cashier/index",
    children: [
      {
        path: "index",
        component: () => import("../../view/Home/cashier.vue"),
      },
    ],
  },
  {
    path: "/downloadapp",
    name: "download",
    component: () => import("../../view/Home/components/container.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
      title: "安装包下载",
      icon: "el-icon-download",
      hidden: true,
    },
    Ischildren: false,
    redirect: "/downloadapp/index",
    children: [
      {
        path: "index",
        component: () => import("../../view/Home/download.vue"),
      },
    ],
  },
];

// 把路由结构转换成树形结构，提供基本的所需信息
function _buildFullPathTree(routes, parentPath = '', parentTitle = '', parentHidden = false) {
  const result = [];

  routes.forEach(route => {
    const fullPath = route.path.startsWith('/')
      ? route.path
      : `${parentPath}/${route.path}`.replace(/\/+/g, '/');
    // 更新到 route 中去
    route.fullPath = fullPath;
    const node = {
      path: fullPath,
      hidden: (route.meta ? route.meta.hidden:false) || parentHidden,
    };

    // 跳过没有 meta 或没有 meta.title 的页面
    // NOTE: 目前的路由树中，一级是分类菜单，二级是具体功能菜单，三级不在左边菜单树中，且三级菜单meta信息不包括title/hidden等。因此菜单显示控制就只考虑一级+二级。
    let fullTitle = ''
    let hidden = false
    if (route.meta) {
      if (route.meta.title) {
        fullTitle = parentTitle ? `${parentTitle}/${route.meta.title}` : route.meta.title
        route.fullTitle = fullTitle;
        node.title = fullTitle;
      }
      hidden = route.meta.hidden || parentHidden;
    }

    if (route.children) {
      const children = _buildFullPathTree(route.children, fullPath, fullTitle, hidden);
      if (children.length) node.children = children;
    }

    result.push(node);
  });

  return result;
}

export default asyncRouterList;

// 直接生成路由树
const asyncRouterTree = _buildFullPathTree(asyncRouterList);
export { asyncRouterTree };



// WEBPACK FOOTER //
// ./src/router/modules/components.js